export const JobUnassigned = 'Unassigned'
export const JobAssigned = 'Assigned'
export const JobProcessing = 'Processing'
export const JobCompleted = 'Completed'
export const JobDeleted = 'Deleted'
export const JobStatus = {
  JobUnassigned,
  JobAssigned,
  JobProcessing,
  JobCompleted,
  JobDeleted
}

export const UnloadingJob = 'Unloading'
export const InboundJob = 'Inbound'
export const OutboundJob = 'Outbound'
export const DivideJob = 'Divide'
export const SplitPalletJob = 'Speration'
export const ScanPalletJob = 'Scan'
export const JobTypes = {
  UnloadingJob,
  InboundJob,
  OutboundJob,
  DivideJob,
  SplitPalletJob
}

export const PalletHold = 'Hold'
export const PalletUnHold = 'UnHold'

export const US_STATES = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

export const AmazonAddress = 'Amazon'
export const WalmartAddress = 'Walmart'
export const FedexAddress = 'Fedex'
export const UPSAddress = 'UPS'
export const OtherAddress = 'Other'

export const CBM_PER_PALLET = 2.0

export const HOLD = 'True'
export const UNHOLD = 'False'
export const SHIPPED = 'Shipped'

export const TypeStack = 'Stack'
export const TypeGround = 'Ground'
export const TypeDock = 'Dock'
export const TypeStage = 'Stage'
export const StackTypes = {
  TypeStack,
  TypeGround,
  TypeDock,
  TypeStage
}

export const SlotNormal = 'Normal'
export const SlotDeleted = 'Deleted'
export const SlotStatus = {
  SlotNormal,
  SlotDeleted
}

export const MAX_PALLETS_IN_SHIPMENT = 90
